import { displayService } from "@/_services/display.service";
import {
  collectDynamicQueueVoiceDefinitions,
} from "@/_helpers/screen-items-helper";

import english from "../locales/en.json";
import french from "../locales/fr.json";
import arabic from "../locales/ar.json";

interface CustomVoiceItem {
  queueId: number;
  language: string;
  voiceText: string;
  voiceLabel: string;
}

interface QueueVoiceEntry {
  queueId: number;
  displaytxt: string;
  voice: string;
}

function getDisplayConfig(): any {
  const display = JSON.parse(localStorage.getItem("display") || "{}");
  return JSON.parse(display.config || "{}");
}

function getDisplayRecord(): any {
  return JSON.parse(localStorage.getItem("display") || "{}");
}

/** Merge dynamic-screen per-queue voices into existing counter storage. */
async function mergeDynamicScreenQueueVoices(language: string): Promise<void> {
  const display = getDisplayRecord();
  const definitions = collectDynamicQueueVoiceDefinitions(
    display.config_screen,
    language
  );
  if (!definitions.length) return;

  const dynamicVoices: QueueVoiceEntry[] = await Promise.all(
    definitions.map((def) =>
      displayService
        .getVoiceTelling({ text: def.voiceText, language })
        .then((response) => ({
          queueId: def.queueId,
          displaytxt: def.voiceLabel,
          voice: response["audio-content"],
        }))
    )
  );

  const counterRaw = localStorage.getItem("counter");
  if (!counterRaw) return;

  const counter = JSON.parse(counterRaw);
  const merged = [...(counter.queueVoices || [])];

  dynamicVoices.forEach((entry) => {
    const idx = merged.findIndex((v: QueueVoiceEntry) => v.queueId === entry.queueId);
    if (idx >= 0) {
      merged[idx] = entry;
    } else {
      merged.push(entry);
    }
  });

  counter.queueVoices = merged;
  localStorage.setItem("counter", JSON.stringify(counter));
}

function scheduleVoiceReload(): void {
  setInterval(() => {
    location.reload();
  }, 2000);
}

export function setLocalVoiceBydisplayLang(language: any) {
  let counter = english.Display.Counter;
  let number = english.Display.Number;

  const config = getDisplayConfig();
  console.log("config", config)

  // checking for customVoiceCounter (classic display — unchanged)
  if (
    config.customVoiceCounter &&
    config.customVoiceCounter !== "[]" &&
    config.customVoiceCounter !== "null"
  ) {
    const callData =
      typeof config.customVoiceCounter === "string"
        ? JSON.parse(config.customVoiceCounter || "[]")
        : config.customVoiceCounter || [];

    const languageVoices = callData.filter(
      (item: CustomVoiceItem) => item.language === language
    );
    if (languageVoices.length > 0) {
      const voicePromises = languageVoices.map((item: CustomVoiceItem) =>
        displayService
          .getVoiceTelling({ text: item.voiceText, language })
          .then((response) => ({
            queueId: item.queueId,
            displaytxt: item.voiceLabel,
            voice: response["audio-content"],
          }))
      );

      Promise.all(voicePromises).then((queueVoices) => {
        counter = languageVoices[0].voiceText;

        displayService
          .getVoiceTelling({ text: counter, language })
          .then((response) => {
            localStorage.setItem(
              "counter",
              JSON.stringify({
                voice: response["audio-content"],
                language,
                queueVoices,
              })
            );
            return mergeDynamicScreenQueueVoices(language);
          });
      });
    }
  }

  if (
    !config.customVoiceCounter ||
    config.customVoiceCounter == "[]" ||
    config.customVoiceCounter == "null" ||
    config.customVoiceCounter == undefined ||
    config.customVoiceCounter == null ||
    !counter
  ) {
    console.log("hhhhheerree")
    switch (language) {
      case "en":
        counter = english.Display.Counter;
        number = english.Display.Number;
        break;
      case "fr":
        counter = french.Display.Counter;
        number = french.Display.Number;
        break;
      case "ar":
        counter = arabic.Display.Counter;
        number = arabic.Display.Number;
        break;
      default:
        counter = english.Display.Counter;
        number = english.Display.Number;
    }
    console.log("counter", counter)
    console.log("number", number)
  } else {
    switch (language) {
      case "en":
        number = english.Display.Number;
        break;
      case "fr":
        number = french.Display.Number;
        break;
      case "ar":
        number = arabic.Display.Number;
        break;
      default:
        number = english.Display.Number;
    }
  }

  if (
    config.voiceNumber &&
    config.voiceNumber != "undefined" &&
    config.voiceNumber !== null &&
    config.voiceNumber !== "null" &&
    config.voiceNumber !== "[]" &&
    config.voiceNumber !== undefined
  ) {
    number = config.voiceNumber;
  }
  if (
    config.voiceCounter &&
    config.voiceCounter != "undefined" &&
    config.voiceCounter !== null &&
    config.voiceCounter !== "null" &&
    config.voiceCounter !== "[]" &&
    config.voiceCounter !== undefined
  ) {
    counter = config.voiceCounter;
  }

  const words = [counter, number];
  console.log("words", words)
  let processedCount = 0;

  words.forEach((word, key) => {
    displayService
      .getVoiceTelling({ text: word, language })
      .then(function (response) {
        localStorage.setItem(
          key == 0 ? "counter" : "number",
          JSON.stringify({
            voice: response["audio-content"],
            language: language,
          })
        );
        processedCount++;

        if (processedCount === words.length) {
          mergeDynamicScreenQueueVoices(language).finally(() => {
            scheduleVoiceReload();
          });
        }
      });
  });
}
